import { useState } from 'react';
import Modal from '@mui/material/Modal';
import Close from '@mui/icons-material/Close';
import './MigrateFileForm.scss';

export default function MigrateFileForm(props) {

    const [cursor] = useState('auto');
    const className = 'migrateFileForm';

    return (
        <Modal
            open={props.open}
            onClose={props.closePopup}
            style={{ cursor: cursor }}>
                <div className={className}>
                    <div className={className + '__inner'}>
                        <div className={className + '__inner__titleBar'}>
                            <text className={className + '__inner__titleBar__title standard-text-semi-large'}>
                                Migrate File
                            </text>
                            <Close className={className + '__inner__titleBar__icons__close close-button'}
                                onClick={props.closePopup}/>
                        </div>
                        <div className={className + '__inner__body'}>
                        </div>
                    </div>
                </div>
        </Modal>
    )
}